import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../utils/translations';
import { Award, Users, TrendingUp, Shield } from 'lucide-react';

const AboutSection = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const features = [
    { icon: Award, label: language === 'en' ? 'Excellence' : '卓越' },
    { icon: Users, label: language === 'en' ? 'Client-Focused' : '以客户为中心' },
    { icon: TrendingUp, label: language === 'en' ? 'Strategic Growth' : '战略增长' },
    { icon: Shield, label: language === 'en' ? 'Trust & Integrity' : '信任与诚信' }
  ];

  return (
    <section id="about" className="py-24 bg-gradient-to-br from-white via-cream-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-serif font-bold text-navy-900 mb-4">{t.about.title}</h2>
          <p className="text-xl text-gold-600 font-medium">{t.about.subtitle}</p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              {t.about.description}
            </p>
            <div className="grid grid-cols-2 gap-4 mt-8">
              {features.map((feature, index) => (
                <div key={index} className="flex items-center gap-3 p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
                  <div className="p-2 bg-navy-100 rounded-lg">
                    <feature.icon className="text-navy-700" size={24} />
                  </div>
                  <span className="font-medium text-navy-800">{feature.label}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="bg-gradient-to-br from-navy-700 to-blue-600 rounded-2xl p-12 text-white shadow-2xl">
              <div className="mb-8">
                <div className="text-6xl font-bold mb-2">16+</div>
                <div className="text-xl opacity-90">{language === 'en' ? 'Years of Experience' : '年经验'}</div>
              </div>
              <div className="space-y-4 text-lg opacity-90">
                <div className="flex items-center gap-3">
                  <div className="w-2 h-2 bg-gold-400 rounded-full"></div>
                  <span>{language === 'en' ? 'Established 2010' : '成立于2010年'}</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-2 h-2 bg-gold-400 rounded-full"></div>
                  <span>{language === 'en' ? 'Hong Kong Based' : '总部位于香港'}</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-2 h-2 bg-gold-400 rounded-full"></div>
                  <span>{language === 'en' ? 'Expert Team' : '专业团队'}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;